import { InputStructureProps } from "../../../Reusables/components/CygnusFormBuilder/CygnusFormBuilder.utils";
import { makeCygnusApiCall } from "../../../api/api";

/**
 * Fetch all grouped templates based on the selected purpose.
 *
 * @returns {Promise<any>} A map of grouped templates.
 */
export const fetchEngagementLetterTemplates = async (): Promise<any> => {
  const response = await makeCygnusApiCall({
    type: "GET",
    url: "/engagement-letter/templates/",
    show_message: true,
    customized_success_message: "Fetched grouped templates.",
    customized_failure_message:
      "Unable to fetch grouped templates. Please try again.",
    customized_error_message:
      "Error occurred while fetching grouped templates.",
    isblob: false,
    forMDM: true,
  });

  if (response.success) {
    if (response.success) {
      return response.data;
    }
  }
};

/**
 * Fetch pre-defined firm template fields used to power Cygnus form dropdowns.
 *
 * @returns {Promise<any>} List of selectable field options.
 */
export const fetchEngagementLetterTemplateFields = async (
  templateId: number
): Promise<any> => {
  const response = await makeCygnusApiCall({
    type: "GET",
    url: `/engagement-letter/template_field_mappings/?TemplateId=${templateId}`,
    show_message: true,
    customized_success_message: "Fetched firm template fields.",
    customized_failure_message: "Unable to fetch firm template fields.",
    customized_error_message:
      "Error occurred while fetching firm template fields.",
    isblob: false,
    forMDM: true,
  });

  if (response.success) {
    return response.data[0];
  }
};

/**
 * Save a new form entry (Draft or Final).
 *
 * @param payload - The full form configuration payload.
 * @returns {Promise<any>} Save result.
 */
export const saveFormData = async (payload: {
  ELFormId?: string | number;
  FormName: string;
  InputStructure: InputStructureProps;
  TemplateId: number;
  Status: string;
  Active?: string;
}): Promise<any> => {
  const response = await makeCygnusApiCall({
    type: "POST",
    url: "/engagement-letter/el_forms/",
    payload,
    show_message: true,
    customized_success_message: "Form saved successfully.",
    customized_failure_message: "Failed to save form. Please try again.",
    customized_error_message: "Error occurred while saving form.",
    isblob: false,
    forMDM: true,
  });

  if (response.success) {
    return response.data;
  }
};

/**
 * Update an existing form using PUT.
 *
 * @param payload - The update configuration payload.
 * @returns {Promise<any>} Update result.
 */
export const updateFormData = async (payload: {
  FirmFormId: string;
  FormName: string;
  FormDescription: string;
  FormPurpose: string;
  InputStructure: InputStructureProps;
  PreviewStructure: any[];
  FormTypeCode: string;
  Type: string;
  Status: string;
}): Promise<any> => {
  const response = await makeCygnusApiCall({
    type: "PUT",
    url: "/forms/",
    payload,
    show_message: true,
    customized_success_message: "Form updated successfully.",
    customized_failure_message: "Failed to update form.",
    customized_error_message: "Error occurred while updating form.",
    isblob: false,
    forMDM: true,
  });

  if (response.success) {
    return response.data;
  }
};
